(ns app.front.view.group.admin.fees.reversal-methods.form
  (:require [app.domain.fee.model :as fee-model]
            [app.front.ui :as ui]
            [app.front.ui.i18n :as ui-i18n]
            [app.front.ui.radio :as ui-radio]
            [app.front.view.group.admin.fees.reversal-methods.events :as rm-events]
            [app.front.view.group.admin.fees.reversal-methods.subs :as rm-subs]
            [app.front.view.group.admin.subs :as gas]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [re-frame.core-instrumented :as rf]))

(defn inline-editor [tr method-id]
  (let [form-data     (<sub [::rm-subs/form-data method-id])
        has-changes?  (<sub [::rm-subs/has-unsaved-changes? method-id])
        is-new?       (= method-id :new)
        method-entity (when-not is-new? (<sub [:app.front.entities/entity method-id]))
        deactivated?  (and method-entity (fee-model/reversal-method-disabled? method-entity))
        in-published? (boolean (:bill-reversal-method.view/in-published-schedule? method-entity))]
    [:div.p-2.bg-gray-50.border-t.space-y-4
     ;; Activation status banner for deactivated methods
     (when (and (not is-new?) deactivated?)
       [:div.p-3.bg-yellow-50.border.border-yellow-200.rounded.text-sm.text-yellow-800
        (tr [:fee.reversal-method/inactive-method-notice])])

     [ui-i18n/edit-language-selector
      {:allowed-locales-sub ::gas/allowed-locales}]

     [ui-i18n/localized-string-edit
      {:id                  (str "reversal-method-titles-" method-id)
       :label-text          (tr [:fee.reversal-method/title])
       :disabled            deactivated?
       :strings             (:titles form-data)
       :required            true
       :on-change           #(rf/dispatch-sync [::rm-events/set-form-data method-id
                                                (assoc form-data :titles %)])
       :allowed-locales-sub ::gas/allowed-locales}]

     [ui-radio/radio {:name        (str "method-type-" method-id)
                      :label-text  (tr [:fee.reversal-method/type])
                      :values      [:bill-reversal-method.type/refund
                                    :bill-reversal-method.type/nsf
                                    :bill-reversal-method.type/void]
                      :value       (:type form-data)
                      :val->str    #(tr [%])
                      :on-change   #(>evt [::rm-events/set-form-data method-id
                                           (assoc form-data :type %)])
                      :required    true
                      ;; Disable type changes when method is in published schedule OR deactivated
                      :disabled    (or deactivated? in-published?)
                      :helper-text (when in-published?
                                     (tr [:error/cannot-change-method-type-in-published-schedule]))}]

     (when (:type form-data)
       [:div.pb-3.pl-3.text-sm.text-gray-600.whitespace-pre-line
        (tr [(case (:type form-data)
               :bill-reversal-method.type/nsf    :fee.reversal-method/type-nsf-description
               :bill-reversal-method.type/refund :fee.reversal-method/type-refund-description
               :bill-reversal-method.type/void   :fee.reversal-method/type-void-description)])])

     [:div.col-span-2
      [ui-i18n/localized-string-edit
       {:id                  (str "reversal-method-messages-" method-id)
        :label-text          (tr [:fee.reversal-method/notification-message])
        :disabled            deactivated?
        :strings             (:messages form-data)
        :required            true
        :multiline?          true
        :on-change           #(rf/dispatch-sync [::rm-events/set-form-data method-id
                                                 (assoc form-data :messages %)])
        :allowed-locales-sub ::gas/allowed-locales}]]

     [:div.flex.justify-between.items-center.mt-6
      [:div.flex.gap-2
       ;; Delete button - only show when NOT in published schedule and NOT new
       (when (and (not is-new?) (not in-published?))
         [ui/modal-confirmation-button
          {:tr                  tr
           :id                  (str "delete-reversal-method-" method-id)
           :on-yes-click        #(>evt [::rm-events/delete-method method-id])
           :trigger-button-text (tr [:fee.reversal-method/remove-method])
           :trigger-button-opts {:kind :tertiary
                                 :icon i/trash
                                 :size :small}}
          (tr [:fee.reversal-method/confirm-delete])])

       ;; Activation toggle button - only show when NOT new
       (when (not is-new?)
         [ui/button {:kind     :secondary
                     :size     :small
                     :on-click #(>evt [::rm-events/toggle-activation method-id (not deactivated?)])}
          (tr [(if deactivated? :fee.reversal-method/activate :fee.reversal-method/deactivate)])])]

      ;; Save/Cancel buttons - only show when there are changes AND method is NOT deactivated
      (when (and has-changes? (not deactivated?))
        [:div.flex.gap-2
         [ui/button {:kind     :tertiary
                     :size     :small
                     :on-click #(>evt [::rm-events/cancel-changes method-id])}
          (tr [:cancel])]
         [ui/button {:kind     :primary
                     :size     :small
                     :on-click #(>evt [::rm-events/submit-form method-id])}
          (tr [:save])]])]]))
